module.exports = __webpack_public_path__ + "img/kucoin.f7c88018.png";